import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M17 11.75a5.75 5.75 0 1 1 0 11.5 5.75 5.75 0 0 1 0-11.5m2.707 4a.75.75 0 0 0-.957-.457c-.482.17-.93.491-1.309.823-.386.34-.745.73-1.046 1.091-.147.175-.281.346-.402.505a2 2 0 0 0-.264-.211c-.16-.106-.385-.251-.729-.251a.75.75 0 0 0-.116 1.491c.056.037.24.184.445.595a.75.75 0 0 0 1.304.066c.163-.23.643-.91.914-1.234a8.4 8.4 0 0 1 .883-.924c.316-.277.596-.458.82-.537a.75.75 0 0 0 .457-.957"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13.974 1.75c.77 0 1.402 0 1.922.051.545.054 1.025.167 1.48.429.455.261.794.62 1.114 1.063.305.424.621.97 1.007 1.635l1.96 3.38c.388.667.706 1.215.923 1.692.228.5.37.974.37 1.5 0 .44-.1.845-.266 1.258a7.23 7.23 0 0 0-6.404-2.45A4.252 4.252 0 0 0 7.75 11.5a4.25 4.25 0 0 0 2.34 3.798 7.3 7.3 0 0 0-.34 2.202c0 1.372.381 2.656 1.044 3.75h-.768c-.77 0-1.402 0-1.922-.051-.545-.054-1.025-.167-1.48-.429-.455-.261-.794-.62-1.114-1.063-.305-.424-.621-.97-1.007-1.635l-1.96-3.38c-.388-.667-.706-1.215-.923-1.692-.228-.5-.37-.974-.37-1.5s.142-1 .37-1.5c.217-.477.535-1.025.922-1.692l1.96-3.38c.387-.665.703-1.211 1.008-1.635.32-.444.66-.802 1.114-1.063.455-.262.935-.375 1.48-.429.52-.051 1.152-.051 1.922-.051z",
      opacity: ".4"
    }, null, -1)
  ])))
}
export default { render: render }